/*
  RevoRope — LA CINTA: carrusel de vídeos de "Cómo funciona".

  MECANISMO: coverflow. Una pieza central en foco y las demás detrás, a los
  lados; se pulsa una lateral (o se usan flechas, teclado, arrastre o rueda
  horizontal) y viene al centro.

  POR QUÉ NO REUTILIZA assets/rr-carousel.js, que ya es un coverflow. Tres
  razones, la primera es la que decide:

  1. Ese controlador no sabe nada de vídeo, y el vídeo es la razón entera por la
     que este archivo existe. Sin arbitrar quién reproduce, las hasta 5 piezas
     se descargarían y se reproducirían A LA VEZ: la sección ya tuvo ese
     problema con UN solo vídeo (era el 46% del peso de la Home, hallazgo del
     audit del 30/07/2026) y por eso existe assets/rr-lazy-video.js. Aquí manda
     la posición horizontal: se reproduce la activa y se pausan las demás.
  2. Tampoco espera a acercarse al viewport para armar nada; esta pieza sí
     (IntersectionObserver con 400px de margen), porque hasta entonces no debe
     descargarse un solo byte de vídeo.
  3. Está atado a los selectores de su sección (.rr-social__stage,
     [data-rr-track], [data-rr-carousel]). Generalizarlo obligaría a tocar la
     pieza de Prueba social, que está fuera de alcance y verificada desde julio.

  Lo que SÍ se reutiliza es su ARQUITECTURA, que es la buena y está probada: el
  controlador no calcula ni un estilo, sólo escribe la POSICIÓN NUMÉRICA de cada
  pieza en variables CSS (--rr-pos = desplazamiento con signo, --rr-depth =
  distancia al centro, --rr-z = orden) y marca activa/ocultas. Toda la
  transformación (rotateY, escala, translateZ, luz) vive en home.css.

  Sin JS la cinta no desaparece: el CSS deja las piezas apiladas en su sitio y
  el contenido sigue ahí. Se pierden las flechas y el contador, no el contenido.
*/
(function () {
  'use strict';

  var VENTANA = 2; // piezas visibles a cada lado de la central
  var GESTO = 45;  // px de arrastre horizontal que valen un paso

  function pad2(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function init(raiz) {
    var pista = raiz.querySelector('[data-rr-cinta-pista]');
    if (!pista) return;

    /* El ESCENARIO es la superficie de arrastre, no la pista, y no es un
       detalle de estilo: la pista lleva `pointer-events: none` porque si no
       se traga todos los impactos de las piezas laterales (viven en z
       negativo, o sea detrás de ella; ver la nota larga en home.css). Los
       eventos de puntero de las piezas burbujean hasta aquí igualmente, y de
       paso se puede arrastrar también desde el aire del escenario. */
    var escena = raiz.querySelector('.rr-cinta__escenario') || pista;

    var slides = Array.prototype.slice.call(raiz.querySelectorAll('[data-rr-cinta-slide]'));
    var n = slides.length;
    if (n < 2) return;

    var pies = Array.prototype.slice.call(raiz.querySelectorAll('[data-rr-cinta-pie]'));
    var prev = raiz.querySelector('[data-rr-cinta-prev]');
    var next = raiz.querySelector('[data-rr-cinta-next]');
    var elIndice = raiz.querySelector('[data-rr-cinta-indice]');
    var elTotal = raiz.querySelector('[data-rr-cinta-total]');
    var elEstado = raiz.querySelector('[data-rr-cinta-estado]');

    // Arranca en la primera y no en la del medio, al revés que el coverflow de
    // Prueba social: allí las piezas son equivalentes (fotos de evento) y
    // abrirlas en abanico equilibrado es lo natural; aquí la primera es el clip
    // que EXPLICA el mecanismo, o sea el motivo de la sección.
    var activo = -1;
    var armado = false;

    if (elTotal) elTotal.textContent = pad2(n);
    raiz.style.setProperty('--rr-cinta-n', n);

    var reduce = window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)')
      : null;

    /* --- Sonido (31/08/2026) ------------------------------------------------
       Los vídeos de la cinta salen de Liquid `muted` y sin controles nativos: es
       requisito del navegador para que el autoplay arranque solo. El vídeo de
       presentación sí tiene banda sonora, así que su bloque declara `con_sonido`
       y Liquid le pinta un botón dentro del fotograma.

       Dos reglas duras, y no se invierten nunca:
       1. el vídeo SIEMPRE empieza en silencio; el botón es la única vía para
          subirlo, y sólo a petición de quien mira;
       2. al dejar de ser la pieza central vuelve a silencio solo, así que el
          sonido no persigue al usuario de una diapositiva a otra ni sobrevive a
          una vuelta atrás.
       El estado accesible (`aria-pressed` + etiqueta) y el visible (qué icono se
       ve) se escriben en el mismo sitio, así que no pueden desincronizarse: el
       CSS enseña un icono u otro leyendo `aria-pressed`. */
    function botonSonido(slide) {
      return slide.querySelector('[data-rr-cinta-sonido]');
    }

    function pintaSonido(btn, suena) {
      if (!btn) return;
      btn.setAttribute('aria-pressed', suena ? 'true' : 'false');
      btn.setAttribute(
        'aria-label',
        suena ? 'Silenciar este vídeo' : 'Activar el sonido de este vídeo'
      );
    }

    /* Arranca el vídeo de la pieza activa y pausa el resto. El vídeo sale de
       Liquid con preload="none" y sin autoplay, así que hasta que no se pide
       aquí no se descarga nada. */
    function media(slide, enciende) {
      var v = slide.querySelector('video');
      if (!v) return;
      if (enciende) {
        if (!v.dataset.rrCintaLista) {
          v.dataset.rrCintaLista = '1';
          v.preload = 'auto';
        }
        var p = v.play();
        if (p && p.catch) {
          p.catch(function () {
            /* Autoplay bloqueado por el navegador: se queda el póster. No es un
               error que se pueda resolver desde aquí. */
          });
        }
      } else {
        if (!v.paused) v.pause();
        // Regla 2: la pieza que deja el centro vuelve a silencio.
        v.muted = true;
        pintaSonido(botonSonido(slide), false);
      }
    }

    function pinta() {
      for (var i = 0; i < n; i++) {
        var desvio = i - activo;
        var abs = Math.abs(desvio);
        var cap = Math.min(abs, VENTANA + 1); // acota escala/translación de las ocultas
        var signo = desvio < 0 ? -1 : (desvio > 0 ? 1 : 0);
        var s = slides[i];

        s.style.setProperty('--rr-pos', signo * cap);
        s.style.setProperty('--rr-depth', cap);
        s.style.setProperty('--rr-z', 100 - cap);

        if (abs > VENTANA) {
          s.setAttribute('data-rr-cinta-oculto', '');
        } else {
          s.removeAttribute('data-rr-cinta-oculto');
        }

        var es = desvio === 0;
        s.classList.toggle('is-activo', es);
        // El fotograma que no está en el centro no es un destino de tabulación
        // ni debe quedar como control suelto para lectores de pantalla.
        s.setAttribute('aria-hidden', es ? 'false' : 'true');

        if (pies[i]) {
          pies[i].classList.toggle('is-activo', es);
          pies[i].setAttribute('aria-hidden', es ? 'false' : 'true');
        }

        // Sólo se reproduce la central, y sólo cuando la pieza ya está armada
        // (o sea, cuando la sección se ha acercado al viewport).
        if (armado) media(s, es);
      }

      if (prev) prev.disabled = activo <= 0;
      if (next) next.disabled = activo >= n - 1;
      if (elIndice) elIndice.textContent = pad2(activo + 1);
      raiz.style.setProperty('--rr-cinta-p', n > 1 ? activo / (n - 1) : 0);
      if (elEstado) elEstado.textContent = 'Vídeo ' + (activo + 1) + ' de ' + n;
    }

    function vaA(i) {
      var j = Math.max(0, Math.min(n - 1, i));
      if (j === activo) return;
      activo = j;
      pinta();
    }

    if (prev) {
      prev.addEventListener('click', function () {
        vaA(activo - 1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        vaA(activo + 1);
      });
    }

    // Teclado sobre la pista. Es enfocable (tabindex=0 en Liquid) porque es la
    // superficie de control del carrusel, igual que en el coverflow.
    pista.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === 'ArrowRight') {
        e.preventDefault();
        vaA(activo + 1);
      } else if (k === 'ArrowLeft') {
        e.preventDefault();
        vaA(activo - 1);
      } else if (k === 'Home') {
        e.preventDefault();
        vaA(0);
      } else if (k === 'End') {
        e.preventDefault();
        vaA(n - 1);
      }
    });

    // Pulsar una lateral la trae al centro. Se anula si el gesto venía de un
    // arrastre, para que soltar el ratón sobre otra pieza no cuente dos veces.
    slides.forEach(function (s, i) {
      s.addEventListener('click', function () {
        if (movido) return;
        vaA(i);
      });
    });

    /* El mando de volumen de cada pieza que lo tenga. Vive DENTRO del fotograma,
       así que sus eventos se cortan aquí: el `click` no debe llegar al <li> (que
       centraría la pieza) y el `pointerdown` no debe llegar al escenario (que
       empezaría un gesto de arrastre bajo el dedo). Nada de esto toca el
       mecanismo del coverflow, sólo evita que el mando nuevo lo dispare. */
    slides.forEach(function (s) {
      var btn = botonSonido(s);
      if (!btn) return;

      btn.addEventListener('pointerdown', function (e) {
        e.stopPropagation();
      });

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var v = s.querySelector('video');
        if (!v) return;
        v.muted = !v.muted;
        // Si el autoplay se quedó bloqueado, este clic es un gesto del usuario:
        // vale para arrancar la reproducción de verdad.
        if (!v.muted && v.paused) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        }
        pintaSonido(btn, !v.muted);
      });
    });

    // --- Arrastre con el puntero (ratón y táctil): un paso por gesto. ---
    var pid = null;
    var x0 = 0;
    var y0 = 0;
    var movido = false;
    var pasado = false;

    function mueve(e) {
      if (e.pointerId !== pid) return;
      var dx = e.clientX - x0;
      var dy = e.clientY - y0;
      if (Math.abs(dx) > 6) movido = true;
      if (!pasado && Math.abs(dx) > GESTO && Math.abs(dx) > Math.abs(dy)) {
        pasado = true;
        vaA(activo + (dx < 0 ? 1 : -1));
      }
    }

    function suelta(e) {
      if (e.pointerId !== pid) return;
      escena.classList.remove('is-arrastrando');
      window.removeEventListener('pointermove', mueve);
      window.removeEventListener('pointerup', suelta);
      window.removeEventListener('pointercancel', suelta);
      pid = null;
      // El click llega DESPUÉS del pointerup: hay que dejar que lea `movido`
      // antes de reiniciarlo.
      setTimeout(function () {
        movido = false;
      }, 0);
    }

    escena.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      pid = e.pointerId;
      x0 = e.clientX;
      y0 = e.clientY;
      movido = false;
      pasado = false;
      escena.classList.add('is-arrastrando');
      window.addEventListener('pointermove', mueve);
      window.addEventListener('pointerup', suelta);
      window.addEventListener('pointercancel', suelta);
    });

    // No arrastrar imágenes/vídeos con el ratón dentro del escenario.
    escena.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    // Rueda/trackpad horizontal. Sólo cuando el eje X domina: nunca bloquea el
    // scroll vertical de la página.
    var ruedaBloqueada = false;
    escena.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY) || Math.abs(e.deltaX) < 12) return;
      e.preventDefault();
      if (ruedaBloqueada) return;
      ruedaBloqueada = true;
      vaA(activo + (e.deltaX > 0 ? 1 : -1));
      setTimeout(function () {
        ruedaBloqueada = false;
      }, reduce && reduce.matches ? 120 : 380);
    }, { passive: false });

    /* Estado visual desde el primer momento (la composición del arco no depende
       de que haya vídeo), pero sin tocar ningún <video> hasta que la sección se
       acerque al viewport. */
    activo = 0;
    pinta();

    function arma() {
      if (armado) return;
      armado = true;
      for (var i = 0; i < n; i++) media(slides[i], i === activo);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (en) {
          if (en.isIntersecting) {
            arma();
            io.disconnect();
          }
        });
      }, { root: null, rootMargin: '400px 0px', threshold: 0 });
      io.observe(raiz);
    } else {
      arma();
    }
  }

  function arranca() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-rr-cinta]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else {
    arranca();
  }
})();
